var _defs, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatSmokeAlarmOff = function SvgFeatSmokeAlarmOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.28 15.27",
    width: 15.28,
    height: 15.27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs189"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style182"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), /*#__PURE__*/React.createElement("path", {
    d: "M 1.35,3.48 2.07,4.2 C 1.44,5.23 1.1,6.42 1.11,7.64 c 0,3.61 2.92,6.53 6.53,6.53 1.21,0 2.4,-0.34 3.43,-0.97 l 0.73,0.72 C 10.57,14.74 9.12,15.17 7.64,15.17 3.48,15.17 0.1,11.79 0.1,7.63 0.1,6.16 0.54,4.71 1.35,3.48 Z M 1.46,0.75 14.52,13.81 13.81,14.52 0.75,1.46 c 0,0 0.71,-0.71 0.71,-0.71 z M 7.64,0.1 c 4.16,0 7.54,3.37 7.54,7.53 0,1.48 -0.43,2.92 -1.25,4.16 L 13.2,11.06 C 13.84,10.03 14.17,8.84 14.17,7.63 14.17,4.02 11.25,1.1 7.64,1.1 6.43,1.1 5.24,1.43 4.21,2.07 L 3.49,1.35 C 4.72,0.54 6.16,0.1 7.64,0.1 Z M 5.18,8.14 c 0.2,0.99 0.97,1.76 1.96,1.96 v 1.02 C 5.6,10.9 4.38,9.68 4.16,8.14 c 0,0 1.02,0 1.02,0 z m 2.96,2.13 0.68,0.68 C 8.6,11.03 8.37,11.08 8.14,11.12 Z m 2.13,-2.13 h 0.85 C 11.08,8.38 11.03,8.6 10.95,8.82 Z M 8.14,4.15 c 1.54,0.22 2.76,1.44 2.98,2.98 H 10.1 C 9.9,6.15 9.13,5.37 8.14,5.17 Z M 4.32,6.45 5,7.13 H 4.16 C 4.19,6.9 4.25,6.67 4.32,6.45 Z M 7.14,4.15 V 5 L 6.46,4.32 C 6.68,4.24 6.9,4.19 7.14,4.15 Z m 4.02,-0.53 c 0.28,0 0.5,0.22 0.5,0.5 0,0.28 -0.22,0.5 -0.5,0.5 -0.28,0 -0.5,-0.22 -0.5,-0.5 -0.01,-0.28 0.22,-0.5 0.5,-0.5 z",
    id: "path184",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgFeatSmokeAlarmOff;